/**
 * 검색 결과 정렬 옵션
 */
export const SORT_OPTIONS = {
  POPULAR: {code: 'POPULAR', title: '트렌드순'},
  RELEVANCE: {code: 'RELEVANCE', title: '정확도순'},
  NEW: {code: 'NEW', title: '최신순'},
  LIKE: {code: 'LIKE', title: '찜 많은순'},
  DISCOUNT: {code: 'DISCOUNT', title: '할인율순'},
  LOW_PRICE: {code: 'LOW_PRICE', title: '낮은 가격순'},
  HIGH_PRICE: {code: 'HIGH_PRICE', title: '높은 가격순'},
};

/**
 * 정렬 옵션 배열로 변환
 */
export const getSortOptionsArray = () => {
  return Object.values(SORT_OPTIONS);
};
